<template>
  <div 
    class="sidebar-menu" 
    :class="{ 'sidebar-menu-hidden': isHidden }"
    @click.stop="onClick"
    @wheel="onWheel"
    @mousedown.stop="onMouseDown"
    @mousemove.stop="onMouseMove"
    @mouseup.stop="onMouseUp"
  >
    <button @click="toggleMenu" :class="isHidden?'sidebar-toggle-button-hide':'sidebar-toggle-button-show'">
      <i class="fas fa-bars"></i> <!-- 使用 Font Awesome 图标库中的图标 -->
    </button>
    <h3>昌平区行政区划</h3>
    <ul class="district-list">
      <div v-if="zj_districts">
        <li v-for="district in zj_districts" :key="district.WYBH" @click="$emit('clickDistrict',district)">
          {{ district.ZJ }}
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SidebarMenu',
  props: {
    zj_districts: {
      type: Array,
      required: true
    },
    map: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isHidden: true
    };
  },
  methods: {
    onClick(event) {
      event.stopPropagation(); // 阻止事件冒泡 
    },
    onWheel(event) {
      const target = event.target;
      const isScrollable = target.classList.contains('district-list');
      if (isScrollable) {
        // 如果是滚动条所在元素，允许滚动
        const { scrollTop, scrollHeight, clientHeight } = target;
        const isAtTop = scrollTop === 0 && event.deltaY < 0;
        const isAtBottom = scrollTop + clientHeight === scrollHeight && event.deltaY > 0;
        if (isAtTop || isAtBottom) {
          // 滚动到顶部或底部时，阻止事件冒泡
          event.stopPropagation();
          event.preventDefault();
        }
      } else {
        // 非滚动条元素，阻止事件冒泡和默认行为
        event.stopPropagation();
        event.preventDefault();
      }
    },
    onMouseDown(event) {
      event.stopPropagation(); // 阻止事件冒泡
    },
    onMouseMove(event) {
      event.stopPropagation(); // 阻止事件冒泡
    },
    onMouseUp(event) {
      event.stopPropagation(); // 阻止事件冒泡 
    },
    toggleMenu() {
      this.isHidden = !this.isHidden;
    },
    selectDistrict(district) {
      this.$emit("clickDistrict",district);
      // 处理选中行政区划的逻辑

      //显示到该区域
      // let bounds = district.polygon.getBounds();
      // let pts = [];
      // pts.push(bounds.getSouthWest());      
      // pts.push(bounds.getNorthEast());   
      // this.map.setViewport(pts);

      // //透明度设置
      // this.zj_districts.forEach(item => {
      //   if(item === district){
      //     item.polygon.setStyle({   
      //       fillColor: 'rgb(255, 0, 0)', // 红色填充，半透明         
      //       fillOpacity: 0.3,
      //       strokeColor: 'rgba(255, 0, 0, 0.5)', // 红色边框，不透明
      //     });
      //   }else{
      //     item.polygon.setStyle({    
      //       fillColor: 'rgb(255, 0, 0)', // 红色填充，半透明        
      //       fillOpacity: 0.1,
      //       strokeColor: 'rgba(0, 0, 255, 0.3)', // 红色边框，不透明
      //     });
      //   }        
      // });
      // //console.log('Selected district:', district.polygon);      
    }
  }
};
</script>

<style scoped>
.sidebar-menu {
  position: fixed;
  left: 0;
  top: 5vh;
  bottom: 0;
  width: 200px;
  background-color: #333;
  color: white;
  transition: transform 0.3s ease-in-out;
  transform: translateX(0);
  z-index: 1000;
 
}

.sidebar-menu-hidden {
  transform: translateX(-100%);
}

.sidebar-toggle-button-hide {
  position: absolute;
  right: -30px; /* 按钮在侧边栏外部 */
  top: 2%;
  transform: translateY(-50%);
  background-color: #333;
  color: white;
  border: none;
  cursor: pointer;
  padding: 10px;
  border-radius: 0 5px 5px 0;
}
.sidebar-toggle-button-show {
  position: absolute;
  right: 2px; /* 按钮在侧边栏外部 */
  top: 2%;
  transform: translateY(-50%);
  background-color: #333;
  color: white;
  border: none;
  cursor: pointer;
  padding: 10px;
  border-radius: 0 5px 5px 0;
}

.district-list {
  list-style: none;
  padding: 0;
  margin: 10px 0 0 10px;
  height: calc(100% - 50px); /* 设置列表高度，减去标题和按钮的高度 */
  overflow-y: auto; /* 添加垂直滚动条 */;
}

.district-list li {
  padding: 10px;
  transition: background-color 0.3s ease-in-out; /* 添加过渡效果 */
}

.district-list li:hover {
  background-color: #555; /* 鼠标悬停时的背景颜色 */
  cursor: pointer; /* 鼠标指针变为手型 */
}

.district-list li a {
  color: white;
  text-decoration: none;
}
</style>
